import React from 'react'

const inputClass = 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent'

interface BaseFieldProps {
  label: string | React.ReactNode
  className?: string
  colSpan?: 2
}

interface TextFieldProps extends BaseFieldProps {
  type: 'text'
  value: string | null | undefined
  onChange: (value: string | null) => void
  placeholder?: string
}

interface NumberFieldProps extends BaseFieldProps {
  type: 'number'
  value: number | null | undefined
  onChange: (value: number | null) => void
  placeholder?: string
  step?: number
  min?: number
  max?: number
}

interface DateFieldProps extends BaseFieldProps {
  type: 'date'
  value: string | null | undefined
  onChange: (value: string | null) => void
}

interface SelectFieldProps extends BaseFieldProps {
  type: 'select'
  value: string | boolean | null | undefined
  onChange: (value: string | boolean | null) => void
  options: { value: string; label: string }[]
  placeholder?: string
}

interface BooleanSelectFieldProps extends BaseFieldProps {
  type: 'boolean-select'
  value: boolean | null | undefined
  onChange: (value: boolean | null) => void
}

export type OverrideFieldProps =
  | TextFieldProps
  | NumberFieldProps
  | DateFieldProps
  | SelectFieldProps
  | BooleanSelectFieldProps

export function OverrideFormField(props: OverrideFieldProps) {
  const { label, colSpan } = props
  const wrapperClass = colSpan === 2 ? 'md:col-span-2' : ''

  return (
    <div className={wrapperClass}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      {props.type === 'text' && (
        <input
          type="text"
          value={props.value || ''}
          onChange={(e) => props.onChange(e.target.value || null)}
          className={inputClass}
          placeholder={props.placeholder}
        />
      )}
      {props.type === 'number' && (
        <input
          type="number"
          step={props.step}
          min={props.min}
          max={props.max}
          value={props.value ?? ''}
          onChange={(e) => props.onChange(e.target.value ? parseFloat(e.target.value) : null)}
          className={inputClass}
          placeholder={props.placeholder}
        />
      )}
      {props.type === 'date' && (
        <input
          type="date"
          value={props.value || ''}
          onChange={(e) => props.onChange(e.target.value || null)}
          className={inputClass}
        />
      )}
      {props.type === 'select' && (
        <select
          value={props.value === null || props.value === undefined ? '' : String(props.value)}
          onChange={(e) => props.onChange(e.target.value || null)}
          className={inputClass}
        >
          <option value="">{props.placeholder || '-- Select --'}</option>
          {props.options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      {props.type === 'boolean-select' && (
        <select
          value={props.value === null || props.value === undefined ? '' : props.value ? 'true' : 'false'}
          onChange={(e) => props.onChange(e.target.value === '' ? null : e.target.value === 'true')}
          className={inputClass}
        >
          <option value="">-- Select --</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      )}
    </div>
  )
}

